module.exports = "<div class=\"ctx-dropdown-content\">\n    <div id=\"{{ctxDropdown.dropdownId}}\"\n         class=\"dropdown\"\n         ng-transclude></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/ctxDropdown/ctxDropdown.template.html
// module id = 151
// module chunks = 0 1